import { render } from "./DialogModal.vue?vue&type=template&id=24c33d16&scoped=true&ts=true"
import script from "./DialogModal.vue?vue&type=script&lang=ts"
export * from "./DialogModal.vue?vue&type=script&lang=ts"

import "./DialogModal.vue?vue&type=style&index=0&id=24c33d16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c33d16"]])

export default __exports__